// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum InternalReportType {
  RoadTollPaymentStatistics = "ROAD_TOLL_PAYMENT_STATISTICS",
  RoadsideChecks = "ROADSIDE_CHECKS",
  Exemptions = "EXEMPTIONS",
  ExemptionsSummary = "EXEMPTIONS_SUMMARY",
  Expenses = "EXPENSES",
  Revenues = "REVENUES",
  BusinessReport = "BUSINESS_REPORT",
}
export default InternalReportType;
